module.exports = __webpack_public_path__ + "res/28-img_game_bg_top.7f9e3abf13ec560ad53896153439f0f8.png";